import React from 'react';
import AppUser from './components';
import Layout from '../../layouts/index';

const User = () => {
    return (
        <Layout>
            <AppUser />
        </Layout>
    );
};

export default User;
